import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageType } from 'enums';
import { createFetchPageAction } from 'common/page/actions';
import carouselSelector from 'common/selectors/carouselSelector';
import { persistentFlagsSelector } from 'common/selectors/flagsSelector';
import Carousel from 'common/page/carousel/Carousel';
import BannerAd from 'common/ads/BannerAd';
import BucketListContainer from './buckets/BucketListContainer';
import MainContainer from './common/MainContainer';
import { convertQueryStringToObject } from 'lib/format';

class Originals extends PureComponent {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(content = {}) {
        const { links: { web = '' } = {} } = content;
        const result = /https?:\/\/[^\/]+\/watch([^\?]+)(.*)$/.exec(web);
        if (!result || !result[1]) {
            return;
        }
        const pathname = result[1];
        let qs = result[2];
        if (qs) {
            qs = convertQueryStringToObject(qs.substr(1));
        }
        const { flags, router } = this.props;

        const query = {
            ...qs,
            ...flags
        };

        router.push({
            pathname,
            query
        });
    }
    render() {
        const { carousel: { contents } = {} } = this.props;
        const bannerAd = [<BannerAd key="banner_ad" />];
        return (
            <MainContainer className="watch-home" pre={bannerAd}>
                <div className="layout-full layout-full--watch">
                    <section className="col-a">
                        <Carousel contents={contents} onClick={this.onClick} />
                        <BucketListContainer pageType={PageType.ORIGINALS} key="bucket_list_container" />
                    </section>
                </div>
            </MainContainer>
        );
    }
}

Originals.propTypes = {
    carousel: PropTypes.object,
    flags: PropTypes.object,
    router: PropTypes.object
};

Originals.loadActions = [
    (params, query, lang) => createFetchPageAction('originals', params, query, lang)
];

const mapStateToProps = (state) => ({
    carousel: carouselSelector(state),
    flags: persistentFlagsSelector(state)
});

export default withRouter(connect(mapStateToProps)(Originals));



// WEBPACK FOOTER //
// ./app/common/page/Originals.js